import TestimonialCard from './TestimonialCard';
import styles from './TestimonialBlock.module.css';

const TestimonialBlock = ({ testimonials = [] }) => {
  if (!testimonials || testimonials.length === 0) return null;

  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <h2 className={styles.heading}>Quem já está usando</h2>
        <div className={styles.grid}>
          {testimonials.map((t, i) => (
            <TestimonialCard key={i} {...t} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialBlock;
